import { ComponentProps } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'

export const ValidateBtn = (props: ComponentProps<typeof Button>) => {
	const { t } = useLingui()

	return (
		<Button
			size='sm'
			type='submit'
			className='flex-1'
			{...props}
		>
			{t`Valider`}
		</Button>
	)
}
